import React from 'react';
import HeaderSeven from '../../components/Header/HeaderSeven';
import TeamMain from './TeamMain';
import Footer from '../../components/Footer';

const Team = () => {
  return (
    <>
      <HeaderSeven />

      <TeamMain />

      <Footer />
    </>
  );
};

export default Team;
